/* ── LINDIE promo banner ──────────────────────────────────────────────
   Upgrades the server-rendered end date into a live countdown.

   The date is rendered by Liquid as plain text first, so a reader without
   JS — or before this file runs — still learns when the offer closes. This
   only replaces it with something better.
   ────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var PARTS = [
    ['d', 'Days'],
    ['h', 'Hrs'],
    ['m', 'Min'],
    ['s', 'Sec']
  ];

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* A date typed into the Customizer, not an ISO string from an API. Safari
     rejects "2026-10-31 23:59" outright, and a bare "2026-10-31" is parsed as
     UTC midnight — which closes the offer during the previous evening for
     anyone west of Greenwich. Both are handled here rather than asking the
     merchant to type something exact. */
  function parseEnd(raw) {
    if (!raw) return null;
    var text = String(raw).trim();

    var m = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?$/);
    if (m) {
      return new Date(
        Number(m[1]),
        Number(m[2]) - 1,
        Number(m[3]),
        m[4] === undefined ? 23 : Number(m[4]),
        m[5] === undefined ? 59 : Number(m[5]),
        m[4] === undefined ? 59 : 0
      );
    }

    /* Anything else is handed to the browser; an unparseable value simply
       leaves the static date in place. */
    var loose = new Date(text);
    return isNaN(loose.getTime()) ? null : loose;
  }

  function build(host) {
    var list = document.createElement('ul');
    list.className = 'lpb__clock';
    list.setAttribute('aria-label', 'Time remaining in this offer');

    var cells = {};
    PARTS.forEach(function (part) {
      var li = document.createElement('li');
      var b = document.createElement('b');
      var label = document.createElement('span');
      b.textContent = '00';
      label.textContent = part[1];
      li.appendChild(b);
      li.appendChild(label);
      list.appendChild(li);
      cells[part[0]] = b;
    });

    host.innerHTML = '';
    host.appendChild(list);
    return cells;
  }

  function start(host) {
    var ends = parseEnd(host.getAttribute('data-lpb-ends'));
    if (!ends) return;

    /* Already over: say so plainly rather than counting up from zero. */
    if (ends.getTime() - Date.now() <= 0) {
      host.innerHTML = '<p class="lpb__ends">This offer has ended</p>';
      return;
    }

    var cells = build(host);
    var timer = null;

    function tick() {
      var left = ends.getTime() - Date.now();
      if (left <= 0) {
        clearInterval(timer);
        host.innerHTML = '<p class="lpb__ends">This offer has ended</p>';
        return;
      }
      var s = Math.floor(left / 1000);
      cells.d.textContent = pad(Math.floor(s / 86400));
      cells.h.textContent = pad(Math.floor(s / 3600) % 24);
      cells.m.textContent = pad(Math.floor(s / 60) % 60);
      cells.s.textContent = pad(s % 60);
    }

    tick();
    timer = setInterval(tick, 1000);

    /* A tab left open for hours drifts, and a backgrounded tab is throttled;
       re-reading the clock on return costs nothing and keeps it honest. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  function init() {
    document.querySelectorAll('[data-lpb-countdown]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* The theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', init);
})();
